// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"413":"container","709":"calendar","791":"video"}[chunkId] || chunkId) + "." + {"83":"226cade5","236":"e35a735d","413":"18c1fe2a","709":"7cac1490","791":"18c1fe2a"}[chunkId] + ".chunk.css";
};